import React, { useState } from "react";

/**
 * Renders a responsive image grid by probing sequentially numbered files
 * (e.g. /images/board/board-1.jpg, board-2.jpg, ...) from the public folder.
 * Missing files are simply hidden, so images can be added later just by
 * dropping them into the public folder — no code changes needed.
 */
const ImageGallery = ({
    folder,
    prefix,
    max = 24,
    extension = "jpg",
    altPrefix = "Image",
    emptyMessage,
    gridClassName = "grid-cols-1 sm:grid-cols-3 lg:grid-cols-3",
    imageClassName = "h-64 w-full sm:h-72 lg:h-80",
    fitClassName = "object-cover",
}) => {
    const [failed, setFailed] = useState({});

    const handleError = (i) => {
        setFailed((prev) => (prev[i] ? prev : { ...prev, [i]: true }));
    };

    const indices = Array.from({ length: max }, (_, i) => i + 1).filter((i) => !failed[i]);

    if (indices.length === 0 && emptyMessage) {
        return <p className="text-slate-500 text-sm italic">{emptyMessage}</p>;
    }

    return (
        <div className={`grid ${gridClassName} gap-4`}>
            {indices.map((i) => (
                <div
                    key={i}
                    className="rounded-xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-md transition-shadow bg-white"
                >
                    <img
                        src={`/images/${folder}/${prefix}${i}.${extension}`}
                        alt={`${altPrefix} ${i}`}
                        className={`w-full ${imageClassName} ${fitClassName}`}
                        loading="lazy"
                        onError={() => handleError(i)}
                    />
                </div>
            ))}
        </div>
    );
};

export default ImageGallery;
